/* @flow */
import { combineReducers } from "redux";
import audio from "./audio";
import authForm from "./authForm";
import graphicalMode from "./graphicalMode";
import stockCategories from "./stockCategories";
import stocks from "./stocks";
import points from "./points";
import deals from "./deals";
import tabs from "./tabs";
import news from "./news";
import settings from "./settings";
import remoteTradeSettings from "./remoteTradeSettings";
import profile from "./profile";
import phoneCallVerification from "./phoneCallVerification";
import dataRequirementsStatus from "./dataRequirementsStatus";
import accounts from "./accounts";
import serverData from "./serverData";
import time from "./time";
import stats from "./stats";
import dictionaries from "./dictionaries";
import socket from "./socket";
import referralBonus from "./referralBonus";
import apiConfigs from "./apiConfigs";
import apiCountries from "./apiCountries";
import fallbackLocale from "./fallbackLocale";
import serverFaults from "./serverFaults";
import helpdesk from "./helpdesk";
import iOSShowDeposit from "./iOSShowDeposit";
import withdrawOutputMethods from "./withdrawOutputMethods";
import firebaseMessaging from "./firebaseMessaging";
import socialTrading from "./socialTrading";

import type { Reducer } from "redux";

const reducers = {
  audio,
  authForm,
  graphicalMode,
  stockCategories,
  stocks,
  points,
  deals,
  tabs,
  news,
  settings,
  remoteTradeSettings,
  profile,
  phoneCallVerification,
  dataRequirementsStatus,
  accounts,
  serverData,
  time,
  stats,
  dictionaries,
  socket,
  referralBonus,
  apiConfigs,
  apiCountries,
  fallbackLocale,
  serverFaults,
  helpdesk,
  iOSShowDeposit,
  withdrawOutputMethods,
  firebaseMessaging,
  socialTrading
};

export default combineReducers(reducers);

export type State = $ObjMap<typeof reducers, <S>(r: Reducer<S, any>) => S>;



// WEBPACK FOOTER //
// ./src/redux/reducer/index.js